import { Injectable } from '@angular/core';
import { Product } from '@core/models/piramide/Product';
import { environment } from '@environments/environment';

@Injectable({
  providedIn: 'root',
})
export class DataLayerService {
  private _window;
  constructor() {
    this._window = window;
  }

  private pushLayer(obj): void {
    if (!obj) return;
    if (environment.localDev) return;
    this._window.dataLayer.push(obj);
  }

  public logEvent(
    event: string,
    action: string,
    category: string,
    label: string,
    value: number = null,
  ): void {
    this.pushLayer({ event, action, category, label, value });
  }

  public cancelReservation(id: number): void {
    this.pushLayer({
      event: 'reservation_cancel',
      action: 'cancel',
      category: 'ecommerce',
      reservationID: id,
    });
  }

  public reservaOK(reservationID: number, reservationValue: number): void {
    this.pushLayer({
      event: 'reservation_ok',
      action: 'reserve',
      category: 'ecommerce',
      reservationID,
      reservationValue,
    });
  }

  public reservaReach(reservationID: number, reservationValue: number, products: Product[]): void {
    if (!products?.length) return;
    this.pushLayer({
      event: 'reservation_reach',
      action: 'reserve',
      category: 'ecommerce',
      reservationID,
      reservationValue,
      productsAMD: products.map((p) => `${p.id_producto}--${p.nombre}`),
    });
  }

  public addToCart(productName: string, value: number): void {
    this.pushLayer({
      event: 'add_to_cart',
      action: 'add',
      category: 'ecommerce',
      productData: productName,
      currency: 'ARS',
      product_value: value,
    });
  }

  public viewCart(cartList: string): void {
    this.pushLayer({
      event: 'view_cart',
      action: 'view',
      category: 'ecommerce',
      cartList,
    });
  }

  public login(id: number): void {
    this.pushLayer({
      event: 'login',
      action: 'login',
      category: 'ecommerce',
      id,
    });
  }

  public signup(mail: string): void {
    this.pushLayer({
      event: 'sign_up',
      action: 'sign_up',
      category: 'ecommerce',
      mail,
    });
  }
}
